import React from 'react';
import AppAccess from './AppAccess';
import { ModuleProps } from 'types';
import getRoutes from './routes';
import RouteModuleFactory from '../@layout/Router/RouteModuleFactory';

const routes = getRoutes();

const ClassroomsModule: React.FC<ModuleProps> = moduleProps => {
  return <RouteModuleFactory IndexComponent={AppAccess} routes={routes} {...moduleProps} />;
};

export default ClassroomsModule;
